export default __webpack_public_path__ + "static/media/logo.f19c7dfd.png";